import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import {alpha} from "@mui/material/styles";

export const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    width: "100%",
  },
  title: {
    marginBottom: 8,
    '@media (max-width: 768px)': {
      marginBottom: 24,
    }
  },
	subtitle: {
    marginBottom: 28,
    '@media (max-width: 768px)': {
      marginBottom: 16,
    }
  },
  content: {
    width: "100%",
    maxWidth: 928,
  },
  field: {
    width: "100%",
    marginBottom: 8,
    '& > div': {
      marginBottom: 0,
    },
    '&:last-of-type': {
      marginRight: 0,
    },

    '@media (max-width: 768px)': {
      marginRight: 0,
      marginBottom: 16,
      maxWidth: '100%',
      width: "100%",
    }
  },
  datepicker: {
    height: 40,
    '& .MuiOutlinedInput-input': {
      padding: '9px 50px 8px 12px'
    },
    '& .PrivatePickersMonth-root:disabled': {
      color: theme.palette.action.disabled,
    },
  },
  form: {
    display: "flex",
    gap: 15,
	  flexDirection: "column",

    '@media (max-width: 768px)': {
      flexDirection: "column",
      gap: 0,
    }
  },
  btn: {
    height: 40,
    width: "100%",
    '@media (max-width: 768px)': {
      width: '100%'
    }
  },
  input_disabled: {
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
      paddingLeft: 0,
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-disabled": {
      color: theme.palette.text.primary,
      opacity: 1,
      left: -14,
    }
  },
  footer: {
    width: '100%',
    display: 'flex',
  },
	actions: {
    width: '100%',
    display: 'flex',
		gap: 17,
  },
  alert: {
    backgroundColor: '#F1F8E9', // уточнить цвет
    padding: '6px 16px',
    maxWidth: 604,
    width: '100%',
    marginRight: 16,
  },
  icons_action: {
    display: "flex",
    width: "auto",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 16,
    gap: 8,
    maxWidth: 72,
    ['@media (max-width: 350px)']: {
      marginLeft: 0,
    }
  },
  collapsed: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.other.outlinedBorder}`,
    padding: '16px 24px',
    maxWidth: 740,
    borderRadius: 4,
  }
}));
